import apiClient from '@/shared/api/client';
import type { ApiResponse } from '@/shared/api/types';

export interface StructuredAddress {
  street?: string;
  city?: string;
  state?: string;
  zip?: string;
  full: string;
}

export interface DayHours {
  open: string;
  close: string;
}

export interface OfficeHours {
  monday?: DayHours | null;
  tuesday?: DayHours | null;
  wednesday?: DayHours | null;
  thursday?: DayHours | null;
  friday?: DayHours | null;
  saturday?: DayHours | null;
  sunday?: DayHours | null;
}

export interface MembershipPlan {
  name: string;
  cost: string;
  benefits: string[];
  moneySaved: string;
}

export interface Phase1Data {
  practiceName?: string;
  phones?: string[];
  addresses?: string[];
  structuredAddress?: StructuredAddress;
  services?: string[];
  providers?: string[];
  technology?: string[];
  insurances?: string[];
  languages?: string[];
  membershipPlans?: MembershipPlan[];
  paymentOptions?: string[];
  officeHours?: OfficeHours;
}

export interface StrategyExtraction {
  id: string;
  locationId: string;
  extracted: Phase1Data;
  status: 'pending_review' | 'confirmed';
  confirmedSections: string[];
  extractedAt: string;
  confirmedAt: string | null;
}

export const extractionApi = {
  get: (locationId: string) =>
    apiClient
      .get<
        ApiResponse<StrategyExtraction | null>
      >('/strategy/extraction', { params: { locationId } })
      .then((r) => r.data),

  run: (locationId: string) =>
    apiClient
      .post<ApiResponse<StrategyExtraction>>('/strategy/extraction/run', { locationId })
      .then((r) => r.data),

  confirm: (locationId: string, confirmed: Phase1Data) =>
    apiClient
      .post<
        ApiResponse<StrategyExtraction>
      >('/strategy/extraction/confirm', { locationId, confirmed })
      .then((r) => r.data),

  saveConfirmedSections: (locationId: string, sections: string[], remove?: string[]) =>
    apiClient
      .patch<ApiResponse<StrategyExtraction>>('/strategy/extraction/confirmed-sections', {
        locationId,
        sections,
        ...(remove?.length ? { remove } : {}),
      })
      .then((r) => r.data),
};
